import { useEffect, useState } from "react"

export class SharedState<V = any> {
    _value: V
    watchers: ((value: V) => void)[] = []
    constructor(value: V) {
        this._value = value
    }

    get value(): V {
        return this._value
    }

    set value(value: V) {
        if (value !== this._value) {
            this._value = value
            for (const watcher of this.watchers) {
                watcher(value)
            }
        }
    }

    addWatcher(watcher: (value: V) => void) {
        this.watchers.push(watcher)
        return () => {
            this.watchers = this.watchers.filter((w) => w !== watcher)
        }
    }
}

export function useWatchSharedState<T>(state: SharedState<T>) {
    const [value, setValue] = useState(state.value)
    useEffect(() => {
        return state.addWatcher((value) => {
            if (typeof value === "function") {
                setValue(() => value)
            } else {
                setValue(value)
            }
        })
    }, [state])
    return value
}
